import styled from 'styled-components';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { typeaheadTheme } from './TypeAheadField.styles';

export const AsyncTypeaheadStyled = styled(AsyncTypeahead)`
  ${typeaheadTheme}
`;
